export function convexSiteUrl(
  siteUrl: string | undefined,
  deploymentUrl: string | undefined,
): string {
  const derivedSiteUrl = deploymentUrl
    ? deploymentUrl
        .replace(/api\.repackify\.com\/?$/, "actions.repackify.com")
        .replace(/\.convex\.cloud\/?$/, ".convex.site")
    : undefined;
  return (siteUrl || derivedSiteUrl || "").replace(/\/$/, "");
}

export function deployedConvexSiteUrl(): string {
  return convexSiteUrl(
    process.env.NEXT_PUBLIC_CONVEX_SITE_URL,
    process.env.NEXT_PUBLIC_CONVEX_URL,
  );
}
